import React from 'react';
import kebabCase from 'lodash/kebabCase';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { IAvailableIconOptions } from '../IconSamples';

export interface IPerksAndBenefitsItem {
	/**
	 * Perk / Benefit Text
	 */
	itemText?: string;
	/**
	 * Perk / Benefit Icon
	 *
	 * @control iconselect
	 */
	itemIcon?: IAvailableIconOptions['calianIconSelectValues'];
}

export interface IPerksAndBenefitsProps extends IBaseElementProps {
	/**
	 * Heading
	 */
	perkAndBenefitsHeading?: string;
	/**
	 * Perks and Benefits Items
	 */
	perkAndBenefitsItems?: IPerksAndBenefitsItem[];
}

/**
 * Calian Perks and Benefits Component
 * @block
 * @icon saved
 */
const PerksAndBenefits: React.FC<IPerksAndBenefitsProps> = ({
	id,
	className,
	classNames = [],
	perkAndBenefitsHeading,
	perkAndBenefitsItems,
}) => (
	<div
		id={id}
		className={className || cn('calian-perks-and-benefits', ...classNames)}
	>
		<div className="calian-perks-and-benefits__container container-fluid">
			<div className="row">
				<div className="col-12">
					{perkAndBenefitsHeading && (
						<h3 className="calian-perks-and-benefits__heading">
							{perkAndBenefitsHeading}
						</h3>
					)}
					{perkAndBenefitsItems && perkAndBenefitsItems.length > 0 && (
						<ul className="calian-perks-and-benefits__list list-unstyled">
							{perkAndBenefitsItems.map(
								({ itemIcon, itemText }, index) => (
									<li
										className="calian-perks-and-benefits__item"
										key={index}
									>
										{itemIcon && (
											<i
												className={`icon icon-${kebabCase(
													itemIcon,
												)}`}
											></i>
										)}
										{itemText && (
											<span className="calian-perks-and-benefits__item-text">
												{itemText}
											</span>
										)}
									</li>
								),
							)}
						</ul>
					)}
				</div>
			</div>
		</div>
	</div>
);

export default PerksAndBenefits;
